import React from "react";

export function Label({ children, htmlFor }) {
  return (
    <label htmlFor={htmlFor} className="block text-xs font-bebas tracking-[0.18em] uppercase text-white/70">
      {children}
    </label>
  );
}

export function Field({ label, value, onChange, type = "text", testid, placeholder }) {
  return (
    <div>
      <Label htmlFor={testid}>{label}</Label>
      <input id={testid} type={type} value={value} onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder} className="input-lifted w-full" data-testid={testid} />
    </div>
  );
}

export function Select({ label, value, onChange, options, testid, placeholder = "Select…" }) {
  return (
    <div>
      <Label htmlFor={testid}>{label}</Label>
      <select id={testid} value={value} onChange={(e) => onChange(e.target.value)}
        className="input-lifted w-full" data-testid={testid}>
        <option value="">{placeholder}</option>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
  );
}

export function Check({ checked, onChange, children, testid }) {
  return (
    <label className="flex items-start gap-2 text-xs text-white/75 cursor-pointer">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 accent-[#b6ff1a]" data-testid={testid} />
      <span>{children}</span>
    </label>
  );
}

export function Honeypot({ value, onChange }) {
  return (
    <div className="hidden" aria-hidden="true">
      <label>Leave this field empty</label>
      <input type="text" tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}
